export default {
    alignToAnchor: Boolean,
    animation: Boolean | Object,
    appendTo: String,
    closeOnClick: Boolean,
    copyAnchorStyles: Boolean,
    dataSource: Object | Array,
    direction: String,
    filter: String,
    hoverDelay: Number,
    orientation: String,
    popupCollision: String,
    showOn: String,
    target: String,

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/ContextMenuProps.js